import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'ebb-please-contactess',
    templateUrl: './please-contactess.component.html',
    styleUrls: ['./please-contactess.component.scss'],
    standalone: false
})
export class PleaseContactEssComponent implements OnInit {
  @Input() message: string;
  constructor() { }

  ngOnInit() {
    const errormessage =  this.getCookie("esserrormessage");
    if(errormessage){
      this.message =errormessage;
      this.eraseCookie("esserrormessage");
    }
    if(this.message == "" || this.message == undefined){
      this.message ="Please contact Customer Service at (877) 232-4300 or at info@crmp.org."
    }
  }
  private getCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for(var i=0;i < ca.length;i++) {
        var c = ca[i];
        while (c.charAt(0)==' ') c = c.substring(1,c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
    }
    return null;
}
private eraseCookie(name) {   
    document.cookie = name +'=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
}
}
